import React from 'react'

export default function ProductLeftsideMenu({children,classProperty,heightValue}) {
  return (
    <div className={classProperty} style={{height:heightValue, fontFamily: "'IBM Plex Sans', sans-serif"}}>{children}</div>
  )
}
